import React, { useState, useEffect } from "react";
import saveAs from 'file-saver';
import { onError, onSuccess } from '../../components/shared/messages';
import { GetDocuments, DeleteDocument } from '../../api/services/pms'
import { useTextResources } from "../../language";
import { Button, Divider, List, Modal } from 'semantic-ui-react'
import PropTypes from "prop-types";
import FileUploader from "../../components/shared/FileUploader";

const UploadFile = ({ documentSpec, ...rest }) => {
    const [isOpen, setIsOpen] = useState(rest.open)
    const text = useTextResources()
    const [reservationDocuments, setReservationDocuments] = useState([])

    const closeHandler = () => {
        rest?.setDocument?.(reservationDocuments)
        rest?.onClose?.()
        setIsOpen(false)
    }

    useEffect(() => {
        if (rest.documents?.length > 0)
            setReservationDocuments(rest.documents)
        else if (rest.open === true) {
            getDocuments()
        }
    }, [rest.open,rest.documents]);

    const getDocuments = () => {
        (async () => {
            try {
                var document = await GetDocuments({ entityTypeId: documentSpec.entityTypeId, entityId: documentSpec.entityId })
                if (document != null)
                    setReservationDocuments(document)

            } catch (error) {
                onError(error);
            }
        })();
    } 

    const handleDelete = (id) => {
        (async () => {
            try {
                await DeleteDocument({ id: id })
                setReservationDocuments((prev) => prev.filter(x => x.Id != id));
                setIsOpen(true)
                onSuccess(text('FileDeletedSuccessfully'))
            } catch (error) {
                onError(error);
            }
        })();
    }

    return <Modal open={isOpen} {...rest} size="large" style={{ width: '40%' }}>
        <Modal.Header>{text("DocumentsUpload")}</Modal.Header>
        <Modal.Content style={{ maxHeight: 690, overflowY: "auto" }}>
            <FileUploader
                documentSpec={documentSpec}
                onUploadComplete={getDocuments}
            />
            <List>
                {reservationDocuments?.map((image) => (
                    <List.Item key={image.Id}>
                        <List.Icon name='attach' />
                        <List.Content>
                            <a
                                className='link-reservation-guest-document'
                                onClick={() => saveAs(image?.Path)}
                            >
                                {image?.Name}
                            </a>
                        </List.Content>
                        <List.Icon
                            name='trash'
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleDelete(image.Id)}
                        />
                        <Divider />
                    </List.Item>
                ))}
            </List>
        </Modal.Content>
        <Modal.Actions>
            <Button negative size="small" onClick={closeHandler}>{text("Close")}</Button>
        </Modal.Actions>
    </Modal>


}
UploadFile.propTypes = {
    documentSpec: PropTypes.object,
}
export default UploadFile;